import {Response} from 'miragejs';
import rs from '../../features/registration/models/registration-statuses-enum';

export let cache: any = {correlationIds: {}};

const statusSequences = new Map<string, rs[]>([
  [rs.Completed, [rs.Received, rs.Validated, rs.VendorMappingSuccess, rs.Completed]],
  [rs.ValidationFailed, [rs.Received, rs.ValidationFailed]],
  [rs.Failed, [rs.Received, rs.Validated, rs.Failed]],
  [rs.VendorMappingFailed, [rs.Received, rs.Validated, rs.VendorMappingFailed]],
  [rs.IdentityCreationFailed, [rs.Received, rs.Validated, rs.IdentityCreationFailed]],
  [rs.IdentityCreationFailedDuplicate, [rs.Received, rs.Validated, rs.IdentityCreationFailedDuplicate]],
  [rs.ProfileCreationFailed, [rs.Received, rs.Validated, rs.IdentityCreated, rs.ProfileCreationFailed]],
  [rs.EmailGenerationFailed, [rs.Received, rs.Validated, rs.VendorMappingSuccess, rs.EmailGenerationFailed]],
  [rs.RollbackCompleted, [rs.Received, rs.Validated, rs.IdentityCreated, rs.ProfileCreated, rs.RollbackCompleted]]
]);

const genStatusRes = (status: string) => new Response(200, {}, {
  data: { registrationStatus: { status: status.toUpperCase() } }
});

const caseGenerator = (correlationIdsCache:any, correlationId:string, steps: rs[]) => {
  const stepIndex = correlationIdsCache[correlationId]-1;
  const status = steps[stepIndex];
  if (!status) return genStatusRes('mock_error');
  if (stepIndex < steps.length-1) correlationIdsCache[correlationId]++;
  return genStatusRes(status);
};

export default function auth0StatusCheckRouter(schema: any, request: any) {
  const correlationId: string = JSON.parse(request.requestBody).variables.correlationId;

  if (!(correlationId in cache.correlationIds)) {
    cache.correlationIds[correlationId] = 1;
  }

  const steps = statusSequences.get(correlationId) || [rs.Received, rs.ValidationFailed];
  return caseGenerator(cache.correlationIds, correlationId, steps);
}
